import React from 'react';

const Work = () => {
  return (
    <div className="work-3__area work-3__inner-wrapper work-3__plr work-3__space">
      <div className="container-fluid">
        <div className="row row-cols-xl-3 row-cols-md-2 justify-content-center">
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="work-3__wrapper inner-wrapper-1 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-1">
                    <span>
                      <i className="fas fa-lightbulb-on"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      IT & Consulting
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="work-3__wrapper inner-wrapper-2 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-1">
                    <span>
                      <i className="fas fa-cogs"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      Healthcare
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".9s"
          >
            <div className="work-3__wrapper inner-wrapper-3 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-1">
                    <span>
                      <i className="fas fa-chart-bar"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      Education
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.0s"
          >
            <div className="work-3__wrapper inner-wrapper-4 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-1">
                    <span>
                      <i className="fas fa-lightbulb-on"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      Ecommerce & Retail
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.1s"
          >
            <div className="work-3__wrapper inner-wrapper-5 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-1">
                    <span>
                      <i className="fas fa-lightbulb-on"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      Insurance
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="work-3__wrapper inner-wrapper-2 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-1">
                    <span>
                      <i className="fas fa-cogs"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      Fintech
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.1s"
          >
            <div className="work-3__wrapper inner-wrapper-5 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-1">
                    <span>
                      <i className="fas fa-lightbulb-on"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      Travel & Hospitality
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="work-3__wrapper inner-wrapper-1 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-1">
                    <span>
                      <i className="fas fa-lightbulb-on"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      Telecommunications
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col col-6 col-12 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".9s"
          >
            <div className="work-3__wrapper inner-wrapper-3 mb-30">
              <div className="work-3__item">
                <div className="work-3__content d-flex align-items-center mb-15">
                  <div className="work-3__icon icon-color-1">
                    <span>
                      <i className="fas fa-chart-bar"></i>
                    </span>
                  </div>
                  <div className="work-3__title">
                    <h4 className="work-3__section-title">
                      Manufacturing
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
